export const reportPrice: Record<TopHap.ReportType, number> = {
  PROPERTY_ONE_PAGE: 1,
  PROPERTY_FULL: 4.98,
  CMA: 7
  // ZMA: 0
}
